<template>
    <v-card flat>
        <v-card-title>
            <v-icon left color="error" class="mr-2">info</v-icon>
            <span class="error--text">Click & Collect Only</span>
        </v-card-title>
        <v-card-text>
            <div>Unfortunately we do not deliver to your postcode at this time, however you can sign up for our Click & Collect service below.</div>
            <div>Please fill in your Delivery information, if we start delivering to your postcode we'll give you the option to select Home Delivery</div>
        </v-card-text>
        <v-card-title>
            <v-icon left color="error" class="mr-2">business</v-icon>
            <span class="error--text subtitle-1 font-weight-bold">Click & Collect Address</span>
        </v-card-title>
        <v-card-text>
            <div class="font-weight-bold">{{cncAddressLine1}}</div>
            <div class="font-weight-bold">{{cncAddressLine2}}</div>
            <div class="font-weight-bold">{{cncAddressLine3}}</div>
            <div class="font-weight-bold">{{cncAddressLine4}}</div>
            <div class="font-weight-bold">{{cncPostcode}}</div>
            <div class="font-weight-bold">{{cncTelephone}}</div>
        </v-card-text>
        <v-card-actions>
            <v-btn
                block
                x-large
                type="submit"
                color="primary"
                @click.stop="goToNextStep"
            > Click & Collect Signup</v-btn>
            </v-card-actions>
        </v-card-actions>
    </v-card>
</template>
<script>
export default {
  name: "ClickAndCollectOnly",
 
  computed:{
    cncAddressLine1() {
      return this.$store.state.configs.cnc_address_line_1;
    },
    cncAddressLine2() {
      return this.$store.state.configs.cnc_address_line_2;
    },
    cncAddressLine3() {
      return this.$store.state.configs.cnc_address_line_3;
    },
    cncAddressLine4() {
      return this.$store.state.configs.cnc_address_line_4;
    },
    cncPostcode() {
      return this.$store.state.configs.cnc_postcode;
    },
    cncTelephone() {
      return this.$store.state.configs.cnc_telephone;
    }
  },
  methods:{
      goToNextStep(){
          this.$emit('valid-cnc-check')
      }
  },
};
</script>